import { z } from 'zod';
/** Identifiant technique : UUID v4 genere par la base. */
export const idSchema = z.string().uuid({ message: 'Identifiant invalide.' });
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(100).default(20),
    sortBy: z.string().optional(),
    sortDir: z.enum(['asc', 'desc']).default('desc'),
    search: z.string().trim().max(200).optional(),
});
/** Numero de telephone francais, format souple (espaces et points acceptes). */
export const phoneSchema = z
    .string()
    .trim()
    .regex(/^(?:\+33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/, {
    message: 'Numero de telephone francais invalide.',
});
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email({ message: 'Adresse e-mail invalide.' });
/**
 * Mot de passe : 12 caracteres minimum avec melange de casses, chiffre et caractere
 * special. Aligne sur les recommandations ANSSI plutot que sur le minimum legal.
 */
export const passwordSchema = z
    .string()
    .min(12, 'Le mot de passe doit contenir au moins 12 caracteres.')
    .max(128, 'Le mot de passe ne peut pas depasser 128 caracteres.')
    .regex(/[a-z]/, 'Le mot de passe doit contenir une minuscule.')
    .regex(/[A-Z]/, 'Le mot de passe doit contenir une majuscule.')
    .regex(/\d/, 'Le mot de passe doit contenir un chiffre.')
    .regex(/[^A-Za-z0-9]/, 'Le mot de passe doit contenir un caractere special.');
// --- Geographie --------------------------------------------------------------
export const latitudeSchema = z.number().min(-90).max(90);
export const longitudeSchema = z.number().min(-180).max(180);
export const coordinatesSchema = z.object({
    lat: latitudeSchema,
    lng: longitudeSchema,
});
/** Position GeoJSON : [longitude, latitude] — l'ordre inverse de l'usage courant. */
export const geoJsonPositionSchema = z.tuple([longitudeSchema, latitudeSchema]);
/**
 * Anneau lineaire : au moins 4 positions, la derniere identique a la premiere
 * (RFC 7946 §3.1.6). Le controle de fermeture est fait ici pour rejeter tres tot
 * un polygone mal forme dessine par l'administrateur.
 */
export const linearRingSchema = geoJsonPositionSchema
    .array()
    .min(4, 'Un anneau doit comporter au moins 4 positions.')
    .refine((ring) => {
    const first = ring[0];
    const last = ring[ring.length - 1];
    return !!first && !!last && first[0] === last[0] && first[1] === last[1];
}, { message: 'Le polygone doit etre ferme : la derniere position doit egaler la premiere.' });
export const geoJsonPolygonSchema = z.object({
    type: z.literal('Polygon'),
    coordinates: linearRingSchema.array().min(1, 'Un polygone requiert au moins un anneau.'),
});
export const geoJsonMultiPolygonSchema = z.object({
    type: z.literal('MultiPolygon'),
    coordinates: linearRingSchema.array().min(1).array().min(1),
});
/** Une zone est soit un polygone simple, soit un multipolygone (quartiers disjoints). */
export const zoneGeometrySchema = z.discriminatedUnion('type', [
    geoJsonPolygonSchema,
    geoJsonMultiPolygonSchema,
]);
// --- Divers ------------------------------------------------------------------
/** Montant en euros, deux decimales maximum, positif. */
export const moneySchema = z
    .number()
    .nonnegative('Le montant ne peut pas etre negatif.')
    .max(99_999.99)
    .refine((value) => Number.isInteger(Math.round(value * 100)), {
    message: 'Le montant ne peut pas comporter plus de deux decimales.',
});
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
    message: 'Date attendue au format AAAA-MM-JJ.',
});
export const isoTimeSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, {
    message: 'Heure attendue au format HH:MM.',
});
//# sourceMappingURL=common.js.map